/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                     from 'react';
import PropTypes                 from 'prop-types';
import { StyledRegularList }     from '../../atoms/StyledRegularList';
import { StyledRegularListItem } from '../../atoms/StyledRegularListItem';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const RegularList = ({ items }) => {

    const List = ({ items }) => (
        <StyledRegularList>
            {items.map((item, index) => (<Item key={index} item={item}/>))}
        </StyledRegularList>
    );

    const Item = ({ item }) => (
        <StyledRegularListItem>
            {item.text}
            {item.children ? <List items={item.children}/> : null}
        </StyledRegularListItem>
    );

    return (
        <List items={items}/>
    );
};

RegularList.propTypes = {
    items: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/molecules/RegularList/index.js